import { ProjectSkeleton } from './components/ProjectSkeleton';
import { useProjectsSkeletonStyles } from './useProjectsSkeletonStyles';

export const ProjectsSkeleton = () => {
  const { classes } = useProjectsSkeletonStyles();

  return (
    <div className={classes.root}>
      <ProjectSkeleton />
      <ProjectSkeleton />
      <ProjectSkeleton />
    </div>
  );
};
